<template>
  <div class="space-y-8">
    <!-- Self Perform Configuration Card -->
    <div class="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div class="px-6 py-4 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-gray-100">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <svg
    viewBox="0 0 24 24"
    fill="none"
 class="w-5 h-5 text-gray-600">
    <path
        d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>

            <h3 class="text-lg font-semibold text-gray-900">
              Self Perform Configuration
            </h3>
          </div>

          <button
            v-if="projectsStore.project?.unarchived"
            type="submit"
            class="btn btn--primary-blue flex items-center space-x-2"
            data-test="save-self-perform"
            :disabled="updateProjectAction.is(States.LOADING)"
            @click="updateProject"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
</svg>

            <span>{{ $t('ProjectSettings.SelfPerformTab.button.saveSettings') }}</span>
          </button>
        </div>
      </div>

      <div class="p-6">
        <form
          class="space-y-8"
          @submit.prevent="updateProject"
        >
          <!-- Production Management Categories -->
          <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            <!-- Activities Card -->
            <div class="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
              <div class="px-4 py-3 border-b border-gray-200 bg-white">
                <div class="flex items-center space-x-2">
                  <svg
    viewBox="0 0 24 24"
    fill="none"
 class="w-4 h-4 text-gray-500">
    <path
        d="M8 5.00005C7.01165 5.00082 6.49359 5.01338 6.09202 5.21799C5.71569 5.40973 5.40973 5.71569 5.21799 6.09202C5 6.51984 5 7.07989 5 8.2V17.8C5 18.9201 5 19.4802 5.21799 19.908C5.40973 20.2843 5.71569 20.5903 6.09202 20.782C6.51984 21 7.07989 21 8.2 21H15.8C16.9201 21 17.4802 21 17.908 20.782C18.2843 20.5903 18.5903 20.2843 18.782 19.908C19 19.4802 19 18.9201 19 17.8V8.2C19 7.07989 19 6.51984 18.782 6.09202C18.5903 5.71569 18.2843 5.40973 17.908 5.21799C17.5064 5.01338 16.9884 5.00082 16 5.00005M8 5.00005V7H16V5.00005M8 5.00005V4.70711C8 4.25435 8.17986 3.82014 8.5 3.5C8.82014 3.17986 9.25435 3 9.70711 3H14.2929C14.7456 3 15.1799 3.17986 15.5 3.5C15.8201 3.82014 16 4.25435 16 4.70711V5.00005"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>

                  <h4 class="text-sm font-medium text-gray-900">
                    {{ $t('ProjectSettings.SelfPerformTab.header.activities') }}
                  </h4>
                </div>

                <p class="text-xs text-gray-500 mt-1">
                  {{ $t('ProjectSettings.SelfPerformTab.tooltip.activities') }}
                </p>
              </div>

              <div class="p-4">
                <div
                  v-if="projectsStore.project?.unarchived"
                  class="flex space-x-2 mb-4"
                >
                  <AppInput
                    v-model="selfPerformForm.form.activity"
                    name="activity"
                    type="text"
                    placeholder="Add activity..."
                    class="form-input flex-1"
                    @keydown.enter.prevent="addToActivityList"
                  />

                  <button
                    type="button"
                    class="btn btn--secondary-blue flex items-center space-x-1"
                    @click.prevent="addToActivityList"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                    <span>{{ $t('ProjectSettings.SelfPerformTab.button.add') }}</span>
                  </button>
                </div>

                <div class="space-y-2 max-h-48 overflow-y-auto">
                  <div
                    v-if="projectForm.form.activities.length > 0"
                    class="space-y-2"
                  >
                    <div
                      v-for="(activity, i) in projectForm.form.activities"
                      :key="i + activity"
                      class="flex items-center justify-between p-2 bg-white rounded border border-gray-200"
                    >
                      <span class="text-sm text-gray-900">{{ activity }}</span>

                      <button
                        v-if="project?.unarchived"
                        type="button"
                        class="btn-icon btn-icon-red"
                        @click="removeActivity(i)"
                      >
                        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
                      </button>
                    </div>
                  </div>

                  <div
                    v-else
                    class="text-center py-6 text-gray-500"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mx-auto h-8 w-8 text-gray-400 mb-2">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                    <p class="text-sm">
                      {{ $t('ProjectSettings.SelfPerformTab.empty.activities') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Elements Card -->
            <div class="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
              <div class="px-4 py-3 border-b border-gray-200 bg-white">
                <div class="flex items-center space-x-2">
                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4 text-gray-600">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
</svg>

                  <h4 class="text-sm font-medium text-gray-900">
                    {{ $t('ProjectSettings.SelfPerformTab.header.elements') }}
                  </h4>
                </div>

                <p class="text-xs text-gray-500 mt-1">
                  {{ $t('ProjectSettings.SelfPerformTab.tooltip.elements') }}
                </p>
              </div>

              <div class="p-4">
                <div
                  v-if="projectsStore.project?.unarchived"
                  class="flex space-x-2 mb-4"
                >
                  <AppInput
                    v-model="selfPerformForm.form.element"
                    name="element"
                    type="text"
                    placeholder="Add element..."
                    class="form-input flex-1"
                    @keydown.enter.prevent="addToElementList"
                  />

                  <button
                    type="button"
                    class="btn btn--secondary-blue flex items-center space-x-1"
                    @click.prevent="addToElementList"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                    <span>{{ $t('ProjectSettings.SelfPerformTab.button.add') }}</span>
                  </button>
                </div>

                <div class="space-y-2 max-h-48 overflow-y-auto">
                  <div
                    v-if="projectForm.form.elements.length > 0"
                    class="space-y-2"
                  >
                    <div
                      v-for="(element, i) in projectForm.form.elements"
                      :key="i + element"
                      class="flex items-center justify-between p-2 bg-white rounded border border-gray-200"
                    >
                      <span class="text-sm text-gray-900">{{ element }}</span>

                      <button
                        v-if="project?.unarchived"
                        type="button"
                        class="btn-icon btn-icon-red"
                        @click="removeElement(i)"
                      >
                        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
                      </button>
                    </div>
                  </div>

                  <div
                    v-else
                    class="text-center py-6 text-gray-500"
                  >
                    <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="mx-auto h-8 w-8 text-gray-400 mb-2">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
    />
</svg>

                    <p class="text-sm">
                      {{ $t('ProjectSettings.SelfPerformTab.empty.elements') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Areas Card -->
            <div class="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
              <div class="px-4 py-3 border-b border-gray-200 bg-white">
                <div class="flex items-center space-x-2">
                  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4 text-gray-600">
    <path d="M18 16.0156C19.2447 16.5445 20 17.2392 20 18C20 19.6568 16.4183 21 12 21C7.58172 21 4 19.6568 4 18C4 17.2392 4.75527 16.5445 6 16.0156" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path d="M17 8.44444C17 11.5372 12 17 12 17C12 17 7 11.5372 7 8.44444C7 5.35165 9.23858 3 12 3C14.7614 3 17 5.35165 17 8.44444Z" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><circle cx="12" cy="8" r="1" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>

                  <h4 class="text-sm font-medium text-gray-900">
                    {{ $t('ProjectSettings.SelfPerformTab.header.areas') }}
                  </h4>
                </div>

                <p class="text-xs text-gray-500 mt-1">
                  {{ $t('ProjectSettings.SelfPerformTab.tooltip.areas') }}
                </p>
              </div>

              <div class="p-4">
                <div
                  v-if="projectsStore.project?.unarchived"
                  class="flex space-x-2 mb-4"
                >
                  <AppInput
                    v-model="selfPerformForm.form.area"
                    name="area"
                    type="text"
                    placeholder="Add area..."
                    class="form-input flex-1"
                    @keydown.enter.prevent="addToAreaList"
                  />

                  <button
                    type="button"
                    class="btn btn--secondary-blue flex items-center space-x-1"
                    @click.prevent="addToAreaList"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

                    <span>{{ $t('ProjectSettings.SelfPerformTab.button.add') }}</span>
                  </button>
                </div>

                <div class="space-y-2 max-h-48 overflow-y-auto">
                  <div
                    v-if="projectForm.form.areas.length > 0"
                    class="space-y-2"
                  >
                    <div
                      v-for="(area, i) in projectForm.form.areas"
                      :key="i + area"
                      class="flex items-center justify-between p-2 bg-white rounded border border-gray-200"
                    >
                      <span class="text-sm text-gray-900">{{ area }}</span>

                      <button
                        v-if="project?.unarchived"
                        type="button"
                        class="btn-icon btn-icon-red"
                        @click="removeArea(i)"
                      >
                        <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
</svg>
                      </button>
                    </div>
                  </div>

                  <div
                    v-else
                    class="text-center py-6 text-gray-500"
                  >
                    <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke-width="1.5"
    stroke="currentColor"
 class="mx-auto h-8 w-8 text-gray-400 mb-2">
    <path d="M18 16.0156C19.2447 16.5445 20 17.2392 20 18C20 19.6568 16.4183 21 12 21C7.58172 21 4 19.6568 4 18C4 17.2392 4.75527 16.5445 6 16.0156" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path d="M17 8.44444C17 11.5372 12 17 12 17C12 17 7 11.5372 7 8.44444C7 5.35165 9.23858 3 12 3C14.7614 3 17 5.35165 17 8.44444Z" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><circle cx="12" cy="8" r="1" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
</svg>

                    <p class="text-sm">
                      {{ $t('ProjectSettings.SelfPerformTab.empty.areas') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Asset and Plant Configuration -->
          <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <AssetTypeList :project-id="$props.projectId" />

            <PlantCategoryList :project-id="$props.projectId" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AssetTypeList from '@/components/ProjectSettings/ProjectTab/AssetTypeList.vue';
import { useFormData } from '@/composables/useFormData';
import { States, useStoreApiAction } from '@/composables/useStoreApiAction';
import { t } from '@/i18n';
import { useProjectsStore } from '@/store/projects';
import Swal from 'sweetalert2';
import { computed, watch } from 'vue';
import WbsCodeList from '../ProjectTab/WbsCodeList.vue';
import PlantCategoryList from './PlantCategoryList.vue';

const props = defineProps<{
  projectId: string;
}>();

const emits = defineEmits<{
  (e: 'dirty');
  (e: 'saved');
}>();

const projectsStore = useProjectsStore();

const project = computed(() => {
  return projectsStore.models.find(parseInt(props.projectId));
});

const projectForm = useFormData({
  activities: [],
  elements: [],
  areas: [],
}, true);

watch(project, (newValue) => {
  if(newValue) {
    projectForm.form.activities = newValue.activities.slice();
    projectForm.form.elements = newValue.elements.slice();
    projectForm.form.areas = newValue.areas.slice();
    projectForm.resetDirtyStatus();
  }
}, { immediate: true });

watch(projectForm.isDirty, (newValue) => {
  if(newValue) {
    emits('dirty');
  } else {
    emits('saved');
  }
});

const updateProjectAction = useStoreApiAction(projectsStore.updateProject);

const updateProject = () => {
  projectForm.resetErrors();

  updateProjectAction.request(props.projectId, projectForm.form).then(() => {
    Swal.fire({
      title: t('ProjectSettings.SelfPerformTab.message.settingsUpdated'),
      icon: 'success',
    });

    projectForm.form.activities = project.value.activities.slice();
    projectForm.form.elements = project.value.elements.slice();
    projectForm.form.areas = project.value.areas.slice();
    projectForm.resetDirtyStatus();
  }).catch((error) => {
    projectForm.setErrors(error.data);
  });
};

const selfPerformForm = useFormData({
  activity: '',
  element: '',
  area: '',
});

const addToActivityList = () => {
  if(selfPerformForm.form.activity) {
    projectForm.form.activities.push(selfPerformForm.form.activity);
    selfPerformForm.form.activity = undefined;
  }
};

const removeActivity = (index: number) => {
  projectForm.form.activities.splice(index, 1);
};

const addToElementList = () => {
  if(selfPerformForm.form.element) {
    projectForm.form.elements.push(selfPerformForm.form.element);
    selfPerformForm.form.element = undefined;
  }
};

const removeElement = (index: number) => {
  projectForm.form.elements.splice(index, 1);
};

const addToAreaList = () => {
  if(selfPerformForm.form.area) {
    projectForm.form.areas.push(selfPerformForm.form.area);
    selfPerformForm.form.area = undefined;
  }
};

const removeArea = (index: number) => {
  projectForm.form.areas.splice(index, 1);
};
</script>

<style scoped></style>
